import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const LogoIntro = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const id = setTimeout(() => setShow(false), 2400);
    return () => { clearTimeout(id); document.body.style.overflow = ""; };
  }, []);

  useEffect(() => {
    if (!show) document.body.style.overflow = "";
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="logo-intro"
          className="fixed inset-0 z-[90] bg-[#F3EFE6] flex items-center justify-center"
          exit={{ y: "-100%" }}
          transition={{ duration: 1, ease }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease }}
            className="flex flex-col items-center"
          >
            <img src="/img/logo-full.jpg" alt="Kashmira&Co" className="w-64 sm:w-80 mix-blend-multiply" />
            <div className="mt-8 h-px w-40 bg-[#E6DFD3] overflow-hidden">
              <motion.div
                className="h-full bg-[#C18A53]"
                initial={{ width: "0%" }}
                animate={{ width: "100%" }}
                transition={{ duration: 2, ease }}
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
